import React from 'react'
import text from './text'
import select from './select'
import multi from './multi'
import bool from './bool'
import number from './number'
import blank from '../blank'

const fieldTypes = {
	text,
	select,
	multi,
	bool,
	number,
	blank,
}

const field = ({ isEditing, isDragging, item, index }) => {
	const Component = fieldTypes[item?.field?.type] || blank

	return (
		<Component
			index={index}
			item={item}
			isDragging={isDragging}
			isEditing={isEditing}
		/>
	)
}

export default field
